"use client";

import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import cn from "clsx";
import styles from "./Faculty.module.scss";
import { useEffect, useRef, useState } from "react";
import { imgPathReplace } from "@/helpers/imgPathReplace";

export default function FacultyCarousel({
  facultyDetails,
  isMobile,
  isCareerPage,isConfigured
}: {
  facultyDetails:any;
  isMobile: boolean;
  isCareerPage?: boolean;
  isConfigured?:boolean
}) {
  const swiperRefLocal = useRef(null);
  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop()
  };

  const handleMouseLeave = () => {
      swiperRefLocal?.current?.swiper?.autoplay?.start()
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const [delayedActiveIndex, setDelayedActiveIndex] = useState(0);
  useEffect(() => {
    const delayTimeout = setTimeout(() => {
      setDelayedActiveIndex(activeIndex);
    }, 300);
    return () => clearTimeout(delayTimeout);
  }, [activeIndex]);
  return (
    <div className={cn(styles.root)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Swiper
        ref={swiperRefLocal}
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        autoplay={{
          delay: 2000,
        }}
        pagination={{ clickable: true }}
        className="Carousel__bottom_only Carousel__hAuto"
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          481: {
            slidesPerView: 1.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 25,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 60,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 50
          },
          1900: {
            slidesPerView: 3,
            spaceBetween: 120
          }
        }}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        onInit={(swiper) => setActiveIndex(swiper.activeIndex)}
      >
        {facultyDetails.map(({ id, attributes }, i) => (
          <SwiperSlide key={id}>
            <FacultySlide isConfigured={isConfigured} isCareerPage={isCareerPage} key={id} faculty={attributes} isMobile={isMobile} index={i}  isActive={isMobile && i === delayedActiveIndex} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

interface Faculty {
  image: string;
  Name: string;
  Department: string;
  Designation: string;
  ShortDesc: string;  
  Picture?: {
    source?: {
      data?: {
        attributes?: {
          url?: string;
        };
      }[];
    };
  };
}

interface MentorItemProps {
  faculty: Faculty;
  isActive:boolean;
  isMobile:boolean;
  index : number;
  isCareerPage?: boolean;
  isConfigured?:boolean
}

const FacultySlide: React.FC<MentorItemProps> = ({ faculty, isActive,isMobile, index,isCareerPage,isConfigured }) => {
const landingImageUrl = faculty?.Picture?.source?.data?.[0]?.attributes?.url || "";
const imagetoShow = isConfigured? landingImageUrl:faculty?.image
return (
    <div className={cn(styles.mentorItem, {
      [styles.active]: isActive,
      [styles.odd]: index % 2 === 0, 
      [styles.even]: index % 2 !== 0,
    })}>
     <div className={`${isCareerPage ? "lg:w-full" : ""} ${styles.mentorImg}`}>
        <img 
           src={imgPathReplace(imagetoShow)}
        srcSet={imgPathReplace(imagetoShow)}
        alt={`${faculty?.Name} Image` || "Amity Online"} 
        title={`${faculty?.Name} Image` || "Amity Online"} 
        width={isMobile ? 289 :257}
        height={isMobile ?269 :224}
        loading="lazy"
        />
      </div>
      <div className={styles.mentorDetailBlock}>
        <div className={styles.mentorDetail}>
          <h3>{faculty?.Name}</h3>
          <p>
            {faculty?.Department} <br />
            {faculty?.Designation}
          </p>
        </div>
        <div className={styles?.mentorDesc}>
          <p>{faculty?.ShortDesc}</p>
        </div>
      </div>
    </div>
  );
};

